(function ($) {
  'use strict';

  /**
   * Collection - Content Block - v1
   */
  Drupal.behaviors.collectionContentBlockV1 = {
    attach: function (context, settings) {
      // Article Reference colorbox modal
      var refLink = $('.article-reference__link > a', context);

      refLink.each(function (index) {
        var refLinkID = $(this).attr('href').substr(1);
        var refContent = $('#' + refLinkID).html();

        $(this).on('click', function (e) {
          generic.overlay.launch({
            content: refContent,
            cssClass: 'article-reference__cboxContent',
            scrolling: false,
            width: '100%',
            maxWidth: '1280px',
            height: 'auto',
            top: 0,
            onLoad: function () {
              $('body, html').scrollTop(0);
            },
            onComplete: function () {
              setTimeout(function () {
                $(this).colorbox.resize();
              }, 1000);
            }
          });

          return false;
        });

        // Sometimes we want to access the article directly
        var refLinkID = $(this).attr('href').substr(1);

        if (window.location.hash.substr(1) == refLinkID) {
          $(this)
            .hide()
            .parents('.collection-content-block-v1')
            .siblings('.article-reference')
            .show();
        }
      });
    }
  };

  /**
   * Collections specific behaviors
   */
  Drupal.behaviors.collectionsCarousel = {
    attach: function (context) {
      // wait until the product list gets sorted based on inventory status, then render the carousel
      $('.shop-the-collection__carousel-slidee', context).bind('products:inventory_sorted', function () {
        // render carousel
        $('.shop-the-collection__carousel-frame', context).each(function (index) {
          var $frame = $(this);
          var $wrap = $frame.parent();
          var $slidee = $('.shop-the-collection__carousel-slidee', $frame);
          var $frameWidth = $(this).width();
          // online-exclusive skus
          var $onlineExclusive = $('.shop-the-collection__online-exclusive', $slidee);

          if ($onlineExclusive.length) {
            $onlineExclusive.last().addClass('last');
          }
          var fixDimensions = function () {
            var width = $slidee.width();

            $slidee.css('width', (width + 10) + 'px'); // fix for firefox/safari subpixel calculations
            $frame.parents('.shop-the-collection').find('.js-match-height').matchHeight();
            if (site.direction.isRTL) {
              var visibleElementWidth = $frameWidth - width;

              $slidee.css('margin-right', (visibleElementWidth - 10) + 'px');
            }
          };
          // Sly object with all our settings
          /* global Sly */
          var collectionSlyCarousel = new Sly($frame, {
            horizontal: true, // Switch to horizontal mode.
            // Item based navigation
            itemNav: 'basic', // Item navigation type. Can be: 'basic', 'centered', 'forceCentered'.
            // itemSelector:   null,  // Select only items that match this selector.
            smart: 1, // Repositions the activated item to help with further navigation.
            activateOn: 'click', // Activate an item on this event. Can be: 'click', 'mouseenter', ...
            // activateMiddle: false, // Always activate the item in the middle of the FRAME. forceCentered only.

            // Scrolling
            scrollSource: $frame, // Element for catching the mouse wheel scrolling. Default is FRAME.
            scrollBy: 1, // Pixels or items to move per one mouse scroll. 0 to disable scrolling.
            // scrollHijack: 100,   // Milliseconds since last wheel event after which it is acceptable to hijack global scroll.
            // scrollTrap:   false, // Don't bubble scrolling when hitting scrolling limits.

            // Dragging
            dragSource: $frame, // Selector or DOM element for catching dragging events. Default is FRAME.
            mouseDragging: 1, // Enable navigation by dragging the SLIDEE with mouse cursor.
            touchDragging: 1, // Enable navigation by dragging the SLIDEE with touch events.
            // releaseSwing:  1, // Ease out on dragging swing release.
            // swingSpeed:    0,   // Swing synchronization speed, where: 1 = instant, 0 = infinite.
            // elasticBounds: false, // Stretch SLIDEE position limits when dragging past FRAME boundaries.
            // interactive:   null,  // Selector for special interactive elements.

            // Scrollbar
            scrollBar: $wrap.find('.shop-the-collection__carousel-scrollbar'), // Selector or DOM element for scrollbar container.
            dragHandle: true, // Whether the scrollbar handle should be draggable.
            dynamicHandle: true, // Scrollbar handle represents the ratio between hidden and visible content.
            minHandleSize: 50, // Minimal height or width (depends on sly direction) of a handle in pixels.
            clickBar: true, // Enable navigation by clicking on scrollbar.
            syncSpeed: 0.5, // Handle => SLIDEE synchronization speed, where: 1 = instant, 0 = infinite.

            // Pagesbar
            // pagesBar:       null, // Selector or DOM element for pages bar container.
            // activatePageOn: null, // Event used to activate page. Can be: click, mouseenter, ...
            // pageBuilder:          // Page item generator.
            //  function (index) {
            //    return '<li>' + (index + 1) + '</li>';
            //  },

            // Navigation buttons
            // forward:  $('.forward', $wrap), // Selector or DOM element for "forward movement" button.
            // backward: $('.backward', $wrap), // Selector or DOM element for "backward movement" button.
            // prev:     $('.prevPage', $wrap), // Selector or DOM element for "previous item" button.
            // next:     $('.nextPage', $wrap), // Selector or DOM element for "next item" button.
            prevPage: $('.prevPage', $wrap), // Selector or DOM element for "previous page" button.
            nextPage: $('.nextPage', $wrap), // Selector or DOM element for "next page" button.

            // Automated cycling
            // cycleBy:       'items',  // Enable automatic cycling by 'items' or 'pages'.
            // cycleInterval: 5000,  // Delay between cycles in milliseconds.
            // pauseOnHover:  false, // Pause cycling when mouse hovers over the FRAME.
            // startPaused:   false, // Whether to start in paused sate.

            // Mixed options
            moveBy: 300, // Speed in pixels per second used by forward and backward buttons.
            speed: 200, // Animations speed in milliseconds. 0 to disable animations.
            // easing:        'swing', // Easing for duration based (tweening) animations.
            startAt: 0, // Starting offset in pixels or items.
            // keyboardNavBy: null,    // Enable keyboard navigation by 'items' or 'pages'.

            // Classes
            draggedClass: 'dragged', // Class for dragged elements (like SLIDEE or scrollbar handle).
            activeClass: 'shop-the-collection__carousel-item--active', // Class for active items and pages.
            disabledClass: 'disabled' // Class for disabled navigation elements.

          }, {
            load: function (eventName) {
              fixDimensions();

              // Click first item in collections carousel to trigger rendering of quickshop,
              // but only when products are ready since this relies on that data
              // load show collection div based on new design
              var collectionText = $('.collection_text');
              var productRenderAnchor = $('.product-render-anchor');
              var shopCollectionQuickShop = $('.shop-the-collection__quickshop');
              var shopCollectionSlidee = $('.shop-the-collection__carousel-slidee');
              var collectionClose = $('.collection_text__close');

              collectionClose.addClass('hidden');
              if (collectionText.length) {
                $('.slidein-clickaway').addClass('collection_text_content');
                shopCollectionQuickShop.add(shopCollectionSlidee).addClass('text_quickshop text-on');
                productRenderAnchor.hide();
                collectionText.show();
                $('.shop-the-collection__quickshop').on('click', function () {
                  var self = $(this);
                  var renderAnchor = self.find(productRenderAnchor);
                  var quickContainer = self.siblings('.shop-the-collection__carousel');
                  var quickShopChild = quickContainer.find(shopCollectionSlidee);

                  self.find(collectionClose).removeClass('hidden').show();
                  self.find(collectionText).hide();
                  renderAnchor.show();
                  self.add(quickShopChild).removeClass('text_quickshop text-on').addClass('text-off');
                });
                collectionClose.on('click', function (e) {
                  e.stopPropagation();
                  var productAnchorClose = $(this).closest(shopCollectionQuickShop);

                  productAnchorClose.find(productRenderAnchor).hide();
                  productAnchorClose.addClass('text_quickshop text-on').removeClass('text-off').find(collectionText).show();
                  productAnchorClose.siblings('.shop-the-collection__carousel').find(shopCollectionSlidee).addClass('text_quickshop text-on').removeClass('text-off');
                  $(this).addClass('hidden');
                });
              } else {
                $frame.find('.js-product-render-trigger').first().trigger('click');
              }

              // give Sly time to load sizes
              setTimeout(function () {
                // Hide arrows if slides width < frame width
                hideArrows($wrap, $slidee);
              }, 1000);
            }
          });

          // recalculate sizes
          $(window).resize(_.debounce(function () {
            collectionSlyCarousel.reload();
          }, 1000));

          // get unique product ids
          var uniqueProducts = $slidee.data('collapsed-prods');

          if (!!uniqueProducts) {
            // convert to array
            uniqueProducts = uniqueProducts.replace(/\s/g, '').split(',');

            // for each unique product
            _.each(uniqueProducts, function (n) {
              // hide all except first
              var $allSkus = $slidee.find('.js-collection-item[data-product-id="' + n + '"]');

              $allSkus.addClass('hidden');
              $allSkus.first().removeClass('hidden').addClass('plus');

              // init toggle to show all
              var $toggle = $allSkus.first().find('.js-collection-item-expand');

              $toggle.removeClass('hidden');
              $toggle.once().click(function () {
                $allSkus.toggleClass('hidden');
                $allSkus.first().removeClass('hidden').toggleClass('plus minus');
                collectionSlyCarousel.reload();

                // re-enable the product details when toggle shaded skus
                var collectionText = $('.collection_text');

                if (collectionText.length) {
                  var textOnCheck = $('.text-off').hasClass('text-on');

                  if (textOnCheck) {
                    $('.text-on.text-off').removeClass('text_quickshop text-on');
                    var collectionTextOff = $('.text-off');

                    collectionTextOff.find(collectionText).hide();
                    collectionTextOff.find('.collection_text__close').removeClass('hidden');
                    collectionTextOff.find('.product-render-anchor').show();
                  }
                }

                return false;
              });
            });
          }

          // Fire quickshop render event on every item change
          collectionSlyCarousel.on('active', function (eventName, itemIndex) {
            site.productApp.$productApp.trigger('quickshop:trigger', [$(this.items[itemIndex].el)]);
          });

          // Only fire it after images are all loaded
          $frame.imagesLoaded(function (instance) {
            collectionSlyCarousel.init();
          });
        });
      });

      // Hide carousel nav arrows if contents are shorter than width of $wrap
      var hideArrows = function ($wrap, $slidee) {
        $wrap.removeClass('shop-the-collection__carousel--no-arrow');
        var wrapWidth = $wrap.width();
        var slideeWidth = $slidee.width();

        if (slideeWidth < wrapWidth) {
          $wrap.addClass('shop-the-collection__carousel--no-arrow');
        }
      };
    }
  };

  /**
   * Add all to cart
   */
  Drupal.behaviors.collectionAddAllToCartV1 = {
    attach: function (context) {
      $('.shop-the-collection', context).on('click', '.shop-the-collection__add-all-link', function (e) {
        e.preventDefault();
        var $collection = e.delegateTarget;
        // Pull the sku_base_id off each DOM element
        var skuBaseIds = $('.js-collection-item', $collection)
          .map(function () {
            return parseInt($(this).data('product').sku_base_id, 10);
          }).get();

        // Add this array of sku_base_ids to the cart
        prodcat.ui.addToCart({ skuBaseId: skuBaseIds.join(', ') });
      });
    }
  };
})(jQuery);
